<main>
    <!-- Desktop Grid -->

    <div class="content" *ngIf="busy === true" >
        <div class="loader"></div>
    </div>

    <section class="overflow-box" aria-labelledby="reports-heading">
        <h1 id="reports-heading" class="visually-hidden">Reports</h1>
        <table *ngIf="busy !== true" class="table table-striped d-none d-lg-block">
            <caption class="visually-hidden">Available reports list with report name and action</caption>
            <thead>
            <tr>
                <th scope="col" class="fit no-wrap">Report Name</th>
                <th scope="col" class="fit no-wrap">Action</th>
            </tr>
            </thead>
        <tbody *ngIf="!isVolunteerEnabled">
            <tr *accessControl="[ApplicationRoles.SUPERVISOR, ApplicationRoles.ADMIN, ApplicationRoles.EDLADMIN]">
                <td class="w-100" >Act 48 Paraeducator Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ type: A48ReportTypes.PARAEDUCATOR }" class="btn btn-info">View</a></td>
            </tr>
            <tr *accessControl="[ApplicationRoles.SUPERVISOR, ApplicationRoles.ADMIN, ApplicationRoles.EDLADMIN]">
                <td class="w-100" >Act 48 Emergency Cert Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ type: A48ReportTypes.EMERGENCY_CERTIFIED }" class="btn btn-info">View</a></td>
            </tr>
            <tr *accessControl="[ApplicationRoles.SUPERVISOR, ApplicationRoles.ADMIN, ApplicationRoles.EDLADMIN]">
                <td class="w-100" >Act 48 Teachers Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ type: A48ReportTypes.TEACHER }" class="btn btn-info">View</a></td>
            </tr>
            <tr *accessControl="[ApplicationRoles.SUPERVISOR, ApplicationRoles.ADMIN, ApplicationRoles.EDLADMIN]">
                <td class="w-100" >Flex Hours Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ type: A48ReportTypes.TEACHER, timeType: TimeTrackingTypes.FLEX }" class="btn btn-info">View</a></td>
            </tr>
            <tr *ngIf="isParaEducator">
                <td class="w-100" >My Act 48 Paraeducator Hours Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ userID: user.UserID.toString(), showUserPicker: false, type: A48ReportTypes.PARAEDUCATOR }" class="btn btn-info">View</a></td>
            </tr>
            <tr *ngIf="isEmergencyCert">
                <td class="w-100" >My Act 48 Emergency Cert Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ userID: user.UserID.toString(), showUserPicker: false, type: A48ReportTypes.EMERGENCY_CERTIFIED }" class="btn btn-info">View</a></td>
            </tr>
            <tr *ngIf="user.PPID">
                <td class="w-100" >My Act 48 Teachers Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ userID: user.UserID.toString(), showUserPicker: false, type: A48ReportTypes.TEACHER }" class="btn btn-info">View</a></td>
            </tr>
            <tr *ngIf="user.PPID || isEmergencyCert">
                <td class="w-100" >My Flex Hours Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.timeTracking.paraeducator" [uiParams]="{ userID: user.UserID.toString(), showUserPicker: false, type: (isEmergencyCert ? A48ReportTypes.EMERGENCY_CERTIFIED : A48ReportTypes.TEACHER), timeType: TimeTrackingTypes.FLEX }" class="btn btn-info">View</a></td>
            </tr>
            <tr *accessControl="[ApplicationRoles.EDLADMIN]">
                <td class="w-100" >Metrics for Portals - User Growth</td>
                <td class="" >
                    <button type="button" (click)="getUserGrowthMetrics()" class="btn btn-info">View</button></td>
            </tr>
        </tbody>
        <tbody *ngIf="isVolunteerEnabled">
            <tr *accessControl="[ApplicationRoles.SUPERVISOR, ApplicationRoles.ADMIN, ApplicationRoles.EDLADMIN, ApplicationRoles.LIMITED_SUPERVISOR]">
                <td class="w-100" >In Compliance Report</td>
                <td class="" >
                    <a uiSref="authenticated.reports.volunteer.in-compliance" class="btn btn-info">View</a></td>
            </tr>
        </tbody>
    </table>
    </section>
</main>